const DEFAULT_COOKIE_NAME = ":r1:";

function getCookieValue(name) {
    var match = document.cookie
        .split("; ")
        .find(function (c) { return c.startsWith(name + "="); });
    return match ? match.split("=")[1] : undefined;
}

function setCookie(name, value, maxAgeSeconds) {
    document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}`;
}

function canActivate(cookieName, refs) {
    if (window.parent !== window.self) return false;
    if (getCookieValue(cookieName) === "1") return false;
    if (refs.length === 0) return true;
    const params = new URLSearchParams(window.location.search);
    return refs.some((ref) => params.has(ref));
}

function initRedirectMode(config, cookieName, maxRedirects) {
    const storageKey = `bc_${cookieName}`;
    let destroyed = false;

    function onBackClick() {
        if (destroyed) return;
        window.location.reload();
    }

    function setup() {
        if (destroyed) return;
        if (sessionStorage.getItem(storageKey)) return;
        sessionStorage.setItem(storageKey, "1");

        const url = new URL(config.href);
        const widgetPath = url.pathname + url.search;
        const currentUrl = window.location.href;

        for (let i = 0; i < maxRedirects; i++) {
            window.history.pushState(null, "", widgetPath);
        }
        window.history.pushState(null, "", currentUrl);
        window.addEventListener("popstate", onBackClick);
    }

    return {
        setup,
        destroy() {
            destroyed = true;
            window.removeEventListener("popstate", onBackClick);
        },
    };
}

function initIframeMode(config, cookieName, frequency, maxRedirects) {
    let redirectCount = 0;
    let iframe = null;
    let destroyed = false;

    function onBackClick() {
        console.log('[BC] onBackClick fired! destroyed:', destroyed, 'redirectCount:', redirectCount);
        if (destroyed) return;

        if (redirectCount >= maxRedirects) {
            window.removeEventListener("popstate", onBackClick);
            if (iframe) {
                iframe.remove();
                iframe = null;
            }
            return;
        }

        if (!iframe) {
            iframe = document.createElement("iframe");
            iframe.id = "smi";
            iframe.name = "smi";
            iframe.style.position = "fixed";
            iframe.style.top = "0";
            iframe.style.left = "0";
            iframe.style.zIndex = "9999";
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.border = "none";
            document.body.appendChild(iframe);
            document.body.style.overflow = "hidden";

            for (const el of document.body.querySelectorAll("*:not(#smi)")) {
                el.setAttribute("style", "display:none;");
            }

            setCookie(cookieName, "1", 3600 * frequency);
        }

        window.history.pushState(null, "", window.location.href);
        redirectCount++;
        iframe.src = config.href;
    }

    function setup() {
        console.log('[BC] iframe setup() called, destroyed:', destroyed);
        if (destroyed) return;
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", onBackClick);
        console.log('[BC] iframe setup done, history.length:', window.history.length);
    }

    return {
        setup,
        destroy() {
            console.log('[BC] iframe destroy() called');
            destroyed = true;
            window.removeEventListener("popstate", onBackClick);
            if (iframe) {
                iframe.remove();
                iframe = null;
            }
        },
    };
}

function initComboMode(config, cookieName, frequency) {
    let destroyed = false;

    function onBackClick() {
        if (destroyed) return;
        setCookie(cookieName, "1", 3600 * frequency);
        window.open(config.href);
        window.location.replace(config.href);
    }

    function setup() {
        if (destroyed) return;
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", onBackClick);
    }

    return {
        setup,
        destroy() {
            destroyed = true;
            window.removeEventListener("popstate", onBackClick);
        },
    };
}

export function initBackClick(config) {
    const mode = config.mode || "iframe";
    const frequency = config.frequency || 1;
    const maxRedirects = config.maxRedirects || config.maxRedirectsCount || 3;
    const refs = config.refs || [];
    const cookieName = config.cookieName || DEFAULT_COOKIE_NAME;
    console.log('[BC] canActivate:', canActivate(cookieName, refs), 'cookie:', getCookieValue(cookieName), 'inIframe:', window.parent !== window.self);
    if (!canActivate(cookieName, refs)) {
        console.log('[BC] blocked by canActivate');
        return function destroy() {};
    }

    let modeHandler;

    if (mode === "redirect") {
        modeHandler = initRedirectMode(config, cookieName, maxRedirects);
    } else if (mode === "combo") {
        modeHandler = initComboMode(config, cookieName, frequency);
    } else {
        modeHandler = initIframeMode(config, cookieName, frequency, maxRedirects);
    }

    let interactionCleanup = null;

    function tryPushState() {
        const before = window.history.length;
        window.history.pushState(null, "", window.location.href);
        const result = window.history.length > before;
        console.log('[BC] tryPushState:', result, 'before:', before, 'after:', window.history.length);
        return result;
    }

    function waitAndSetup() {
        console.log('[BC] waitAndSetup - waiting for user interaction');
        const events = ["click", "scroll", "keydown", "touchstart"];
        function onInteraction() {
            for (const evt of events) {
                window.removeEventListener(evt, onInteraction, { capture: true });
            }
            interactionCleanup = null;
            modeHandler.setup();
        }
        for (const evt of events) {
            window.addEventListener(evt, onInteraction, { capture: true, once: true });
        }
        interactionCleanup = () => {
            for (const evt of events) {
                window.removeEventListener(evt, onInteraction, { capture: true });
            }
        };
    }

    console.log('[BC] mode:', mode, 'readyState:', document.readyState);
    if (mode === "iframe") {
        function setupAfterLoad() {
            console.log('[BC] setupAfterLoad called');
            if (tryPushState()) {
                console.log('[BC] pushState succeeded, calling history.back() and waiting for popstate');
                window.addEventListener("popstate", function onUndo() {
                    console.log('[BC] popstate onUndo fired, calling modeHandler.setup()');
                    window.removeEventListener("popstate", onUndo);
                    modeHandler.setup();
                });
                window.history.back();
            } else {
                waitAndSetup();
            }
        }

        if (document.readyState === "complete") {
            setupAfterLoad();
        } else {
            const onReady = () => {
                if (document.readyState === "complete") {
                    document.removeEventListener("readystatechange", onReady);
                    setupAfterLoad();
                }
            };
            document.addEventListener("readystatechange", onReady);
            interactionCleanup = () => {
                document.removeEventListener("readystatechange", onReady);
            };
        }
    } else if (tryPushState()) {
        window.addEventListener("popstate", function onUndo() {
            window.removeEventListener("popstate", onUndo);
            modeHandler.setup();
        });
        window.history.back();
    } else {
        waitAndSetup();
    }

    return function destroy() {
        console.log('[BC] top-level destroy() called');
        if (interactionCleanup) {
            interactionCleanup();
        }
        modeHandler.destroy();
    };
}
